import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from '@mui/material';
export const BulletItem = t0 => {
  const $ = _c(16);
  const {
    title,
    leftContent,
    rightContent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      gap: "100px",
      justifyContent: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "24px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = title && <Typography sx={{
      width: "540px"
    }} variant="body1">{title}</Typography>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "440px"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== leftContent) {
    t5 = <Box sx={t4}>{leftContent}</Box>;
    $[5] = leftContent;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <Stack sx={t2}>{t3}{t5}</Stack>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: "50%"
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== rightContent) {
    t8 = <Box sx={t7}>{rightContent}</Box>;
    $[11] = rightContent;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <Stack direction="row" sx={t1}>{t6}{t8}</Stack>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};